var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'workspace-skin': !_vm.$route.path.endsWith('/tr-create') }},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[(!_vm.$route.meta.link)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }